import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { ButtonListSelect } from 'app/components/common/button-list-select/button-list-select';
import { FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { ALL_PERIODS, Period, PeriodLabels } from 'app/console-api/statistics/types';

export const PeriodFilterAdapter: FilterAdapter<string> = {
  key: 'period',
  fromUrl: (sp) => {
    const raw = sp.get('period');
    if (!raw) return null;
    return raw;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('period');
    } else {
      next.set('period', value);
    }
    return next;
  },
  toKey: (v) => `period:${v || 'none'}`
};

export const PeriodFilter = () => {
  const ctl = useUrlFilterController();
  const value = ctl.get(PeriodFilterAdapter) || Period.Day;
  return (
    <FlexRow justify={'space-between'} gap={4}>
      {ALL_PERIODS.map((item) => (
        <ButtonListSelect
          onClick={() => {
            ctl.set(PeriodFilterAdapter, item);
          }}
          value={PeriodLabels[item]}
          active={value == item}
          key={item}
        />
      ))}
    </FlexRow>
  );
};
